import { renderRequiredRule } from "@/utils/renderRulesForm";

export default (applicationCargoPickup) => ({
  isCargoPickup: [],
  addressCargoPickup: [
    {
      validator: (rule, value, callback) => {
        if (value === "" && !applicationCargoPickup.adressDetailRequired) {
          callback(new Error("Пожалуйста введите адрес"));
        }
        if(applicationCargoPickup.addressSelected == false && !applicationCargoPickup.adressDetailRequired) {
          callback(new Error("Пожалуйста выберите адрес из списка"));
        }
        callback();
      },
      trigger: "blur",
      
    }
  ],
  pickupDate: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && value === "") {
          callback(new Error("Пожалуйста выберите дату"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cargoStartTimePickup: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && value === "") {
          callback(new Error(""));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cargoEndTimePickup: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && value === "") {
          callback(new Error(""));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  startTimeLunchBreak: [],
  endTimeLunchBreak: [],
  startTimeLunchBreakDelivery: [],
  endTimeLunchBreakDelivery: [],
  addressCargoPickupNotice: {
    validator: (rule, value, callback) => {
      if (value === "" && applicationCargoPickup.adressDetailRequired) {
        callback(new Error("Пожалуйста введите адрес"));
      }
      if (value.length < 3 && applicationCargoPickup.adressDetailRequired) {
        callback(new Error("Пожалуйста введите больше 3 символов"));
      }
      callback();
    },
    trigger: "blur",
  },
  addressCargoPickupNoticeTo: {
    validator: (rule, value, callback) => {
      if (value === "" && applicationCargoPickup.adressDetailRequiredTo) {
        callback(new Error("Пожалуйста введите адрес"));
      }
      if (value.length < 3 && applicationCargoPickup.adressDetailRequiredTo) {
        callback(new Error("Пожалуйста введите больше 3 символов"));
      }
      callback();
    },
    trigger: "blur",
  },
  deliveryToTheAddress: false,
  addressConsignee: {
    validator: (rule, value, callback) => {
      if (value === "" && !applicationCargoPickup.adressDetailRequiredTo) {
        callback(new Error("Пожалуйста введите адрес"));
      }
      if(applicationCargoPickup.addressSelectedTo == false && !applicationCargoPickup.adressDetailRequiredTo) {
        callback(new Error("Пожалуйста выберите адрес из списка"));
      }
      callback();
    },
    trigger: "blur",
    
  },
  deliveryDate: [renderRequiredRule("Пожалуйста выберите дату")],
  cargoStartTimeDelivery: [renderRequiredRule("")],
  cargoEndTimeDelivery: [renderRequiredRule("")],
  

  dataOnTheDriver: [],
  comment: [],
});
